import { createActions } from 'redux-actions';

export const actions = createActions({
  APP: {
    INIT: () => {},
    LOAD: (ssid) => ssid,
    FLUSH: () => {},
  },
}).app;
